module.exports = __webpack_public_path__ + "static/media/gg.9487446e.svg";